export default __webpack_public_path__ + "static/media/pm.edfdc748.svg";